import { render, staticRenderFns } from "./geschat-aantal-ramen.vue?vue&type=template&id=93f50126"
import script from "./geschat-aantal-ramen.vue?vue&type=script&lang=js"
export * from "./geschat-aantal-ramen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports